import React, { Component } from 'react';
import AssessmentGrader from './AssessmentGrader';
import { observer } from 'mobx-react';
import { Grid, Form, Segment, Header } from 'semantic-ui-react';
import RichTextEditor from 'react-rte';
import { toolbarConfig } from '../RichTextEditorConfig';

class CompanyOverviewAssessmentCompleter extends Component {
    constructor(props) {
        super();

        this.state = {
            areasForImprovement: RichTextEditor.createValueFromString(props?.assessment?.companyOverviewAreasForImprovementView || '', 'markdown'),
            positives: RichTextEditor.createValueFromString(props?.assessment?.companyOverviewPositivesView || '', 'markdown'),
        }
    }

    onGradeChange = (grade) => {
        const { assessment } = this.props;
        assessment.updateFromEvent({ target: { id: 'grade', value: grade } });
    }

    onSessionTypeChange = data => {
        const { assessment } = this.props;
        assessment.setSessionType(data.value);
    }

    onAreasForImprovementChange = (event) => {
        const { assessment } = this.props;

        this.setState({ areasForImprovement: event });
        assessment.updateFromEvent({ target: { id: 'companyOverviewAreasForImprovement', value: event.toString('markdown') } });
    }

    onPositivesChange = (event) => {
        const { assessment } = this.props;

        this.setState({ positives: event });
        assessment.updateFromEvent({ target: { id: 'companyOverviewPositives', value: event.toString('markdown') } });
    }

    render() {
        const { assessment } = this.props;
        const reviewDate = new Date(assessment.reviewDateTime);
        const todaysDate = new Date();

        return (<Grid>
            <Grid.Row>
                <Grid.Column width="14">
                    <Grid>
                        <Grid.Row columns={2}>
                            <Grid.Column>
                                <Form.Input
                                    label="Scheduled Review Date"
                                    id="dateAssigned"
                                    readOnly
                                    value={reviewDate.toLocaleDateString()}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Form.Input
                                    label="Actual Review Date"
                                    id="reviewDate"
                                    readOnly
                                    value={todaysDate.toLocaleDateString()} />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Form.Input
                                    id="sessionType"
                                    label="Session Type"
                                    readOnly
                                    value={assessment.sessionType || ''} />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Segment>
                                    <Header>Company Overview</Header>
                                    <Form.Field required>
                                        <label>Positives</label>
                                        <RichTextEditor
                                            data-testid="companyOverviewPositives"
                                            id="companyOverviewPositives"
                                            value={this.state.positives}
                                            onChange={this.onPositivesChange}
                                            toolbarConfig={toolbarConfig}
                                        />
                                    </Form.Field>
                                    <Form.Field required>
                                        <label>Areas for Improvement</label>
                                        <RichTextEditor
                                            data-testid="companyOverviewAreasForImprovement"
                                            id="companyOverviewAreasForImprovement"
                                            value={this.state.areasForImprovement}
                                            onChange={this.onAreasForImprovementChange}
                                            toolbarConfig={toolbarConfig}
                                        />
                                    </Form.Field>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Grid.Column>
                <Grid.Column textAlign="center" width="2">
                    <AssessmentGrader onGradeChange={this.onGradeChange} value={assessment.grade} />
                </Grid.Column>
            </Grid.Row>
        </Grid>);
    }
}

export default observer(CompanyOverviewAssessmentCompleter);